/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDomainAuditInput
 */
export interface ProjectDomainAuditInput {
    /**
     * Inclusive start date without a range-length limit.
     * @type {string}
     * @memberof ProjectDomainAuditInput
     */
    since?: string;
    /**
     * Inclusive end date without a range-length limit.
     * @type {string}
     * @memberof ProjectDomainAuditInput
     */
    until?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectDomainAuditInput
     */
    integrationTypes?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProjectDomainAuditInput
     */
    decisions?: Array<string>;
}

/**
 * Check if a given object implements the ProjectDomainAuditInput interface.
 */
export function instanceOfProjectDomainAuditInput(value: object): value is ProjectDomainAuditInput {
    return true;
}

export function ProjectDomainAuditInputFromJSON(json: any): ProjectDomainAuditInput {
    return ProjectDomainAuditInputFromJSONTyped(json, false);
}

export function ProjectDomainAuditInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDomainAuditInput {
    if (json == null) {
        return json;
    }
    return {
        
        'since': json['since'] == null ? undefined : json['since'],
        'until': json['until'] == null ? undefined : json['until'],
        'integrationTypes': json['integrationTypes'] == null ? undefined : json['integrationTypes'],
        'decisions': json['decisions'] == null ? undefined : json['decisions'],
    };
}

export function ProjectDomainAuditInputToJSON(json: any): ProjectDomainAuditInput {
    return ProjectDomainAuditInputToJSONTyped(json, false);
}

export function ProjectDomainAuditInputToJSONTyped(value?: ProjectDomainAuditInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'since': value['since'],
        'until': value['until'],
        'integrationTypes': value['integrationTypes'],
        'decisions': value['decisions'],
    };
}

